import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const THTPlacements = (props) => {
  const name = 'thru_hole';

  const {
    label,
    errorMessage,
    parameters,
    inputId,
    tooltip,
    groupName,
    onChangeParameter,
    required,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      name={name}
      label={label}
      inputId={inputId}
      value={parameters[name]}
      tooltip={tooltip}
      required={required}
      groupName={groupName}
      onChange={onChange}
      errorMessage={errorMessage}
      disabled={disabled} />
  );
};

THTPlacements.defaultProps = {
  label: Spree.translations.parameters.thru_hole,
  tooltip: Spree.helpForParameters.thru_hole,
  required: true,
  inputId: 'thru-hole',
};

export default THTPlacements;
